/**
 * Replaces spaces after single-letter words with non-breaking spaces.
 * Targeted at Polish typography (hanging conjunctions).
 *
 * @param {string} selector
 */
export const fixOrphans = (selector = 'p, h1, h2, h3, h4, h5, h6, li') => {
    const elements = document.querySelectorAll(selector);

    // Unicode-aware: Match any single letter not preceded by another letter, followed by space
    const regex = /(?<!\p{L})(\p{L})\s+/gu;

    elements.forEach(el => {
        const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
        let node;
        while (node = walker.nextNode()) {
            node.nodeValue = node.nodeValue.replace(regex, '$1\u00A0'); // Replace space with &nbsp;
        }
    });
};
